import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Badge } from 'Components/frameworks/badge/Badge';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
export type ProductFavoriteProps = {
  className?: string;
  'data-testid'?: string;
  iconName?: string;
  isDisabled?: boolean;
  onClick?: () => void;
  total?: number;
};
export const ProductFavorite = ({
  className,
  iconName = ICONS.STAR_HOLLOW,
  isDisabled = false,
  total = 0,
  ...rest
}: ProductFavoriteProps) => (
  <button
    {...rest}
    className={classnames('flex items-center justify-center leading-loose text-inherit', className)}
    disabled={isDisabled}
    type="button"
  >
    <span className="relative isolate flex">
      <Icon name={iconName} width="1.5rem" />
      {Boolean(total) && (
        <Badge
          className="top-O absolute end-0 -me-10 -mt-5 size-[21px] border-white bg-success text-12 font-bold text-white"
          label={String(total)}
          variant="pill"
        />
      )}
    </span>
  </button>
);
